import { render, staticRenderFns } from "./MasterProposalCp.vue?vue&type=template&id=35d74f40&scoped=true&"
import script from "./MasterProposalCp.vue?vue&type=script&lang=js&"
export * from "./MasterProposalCp.vue?vue&type=script&lang=js&"
import style0 from "./MasterProposalCp.vue?vue&type=style&index=0&id=35d74f40&prod&lang=css&"
import style1 from "./MasterProposalCp.vue?vue&type=style&index=1&id=35d74f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d74f40",
  null
  
)

export default component.exports